"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak

exports.default = {
  RESISTANCE_COEF: 0.6,

  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 };


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-core/lib/constant.js
// module id = 161
// module chunks = 0